import actions from './actions'

export default function ClinBudgetsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CLINBUDGET:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CLINBUDGET:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CLINBUDGET:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }

    case actions.RESET_WORKORDER_BUDGETS_RECIEVED:
      return {
        ...state,
        workOrderBudgets: null,
        loading: false,
      }
    case actions.FETCH_WORKORDER_BUDGETS_RECIEVED:
      return {
        ...state,
        loading: false,
        workOrderBudgets: action.result,
      }
    case actions.FETCH_CLINBUDGET_REPORT_RECEIVED:
      return {
        ...state,
        loading: false,
        reportData: action.result,
      }

    case actions.NEW_CLINBUDGET:
      return {
        ...state,
        // action.editing lets callers prefill the dialog (e.g. the "CLIN and
        // Budget" grid passes costTypeID when a budget-less CLIN row is opened).
        editing: { clinBudgetID: 0, ClinBudgetID: 0, ...(action.editing || {}) },
        loading: false,
        saveSuccess: false,
      }

    case actions.CREATE_CLINBUDGET_RECIEVED ||
      actions.UPDATE_CLINBUDGET_RECIEVED ||
      actions.DELETE_CLINBUDGET_RECIEVED:
      return {
        ...state,
        editing: { ClinBudgetID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
        saveFailed: (state.saveFailed || 0) + 1, // edit.js stops its spinner on this
      }
    default:
      return state
  }
}
